<ng-container *ngIf="cookieValue != 'true'">
  <ng-container *ngIf="$data | async as data">
    <div class="cookie-banner-wrapper" [@cookieAnimation]>
      <p class="small-p">{{data.text}}</p>
      <button (click)="handleGotIt()" class="large-p">{{data.buttonText}}</button>
    </div>
  </ng-container>
</ng-container>

